// Import Bootstrap javascript
import 'bootstrap';
// import 'bootstrap/js/dist/util'
// import 'bootstrap/js/dist/dropdown'
// import 'bootstrap/js/dist/button'
// import 'bootstrap/js/dist/collapse'
// import 'bootstrap/js/dist/carousel'
// import 'bootstrap/js/dist/modal'

// Import custom styles
import '../scss/profit_plus.scss';

import './sendform.js';

import './offcanvas.js';

// Enabling HMR
if (module.hot) {
    module.hot.accept(console.log('Aceptando nuevos cambios...'));
}
